const _findZonaEditable = (structure) => {
    let zonaEditable;
    if (structure.length > 0) {
        for (var i = 0; i < structure.length; i++) {
            const component = structure[i];
            if (component.name === 'ZonaEditable') {
                zonaEditable = component;
                break;
            } else if (component.children) {
                zonaEditable = _findZonaEditable(component.children);
            }
        }
    }
    return zonaEditable;
};

export const getZonaEditable = (structure) => {
    const zonaEditable = _findZonaEditable(structure);
    if (!zonaEditable) {
        console.log("No s'ha trobat ZonaEditable.")
    }
    return zonaEditable;
}